import Model from "@/models/Model";
import PrintArea from "@/models/PrintArea";
import WarehouseItemArtifact from "@/models/WarehouseItemArtifact";

export default class WarehouseItem extends Model {

	static type = "warehouseItems";
	name: string;
	image: string;
	code: string;
	warehouseItemArtifact: WarehouseItemArtifact;
	printAreas!: PrintArea[];
}
